import React from 'react';
import PropTypes from 'prop-types';

// Base
import Button from '../button';

// Related Components
import ModalContext from './context';

export default class ModalOpenButton extends React.PureComponent {
  static contextType = ModalContext;

  static propTypes = {
    onOpenModal: PropTypes.func,
    onClick: PropTypes.func,
  }

  static defaultProps = {
    onOpenModal: undefined,
    onClick: () => {},
  }

  handleClick = (event) => {
    const {
      onClick,
      onOpenModal,
    } = this.props;

    onClick(event);

    const openModal = onOpenModal || this.context?.openModal;

    if (openModal) {
      openModal();
    }
  }

  render() {
    const {
      onOpenModal,
      ...props
    } = this.props;

    return (
      <Button
        {...props}
        onClick={this.handleClick}
      />
    )
  }
}
